<div class="max-w-7xl mx-auto p-6 full-height-container">
  <div class="bg-white rounded-lg shadow-md p-6 full-height-container">
    <div class="ai-container">
      <div #aiModalContainer class="w-full h-full">
        <!-- AI Engine will mount here -->
        <div class="w-full h-full flex items-center justify-center" *ngIf="isProcessing">
          <p>{{ processingMessage }}</p>
        </div>
      </div>
    </div>
  </div>
</div>